import { Preferences, Account } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editUserPreferences(httpClient: HttpClient) {
  return (account: Account, preferences: Preferences) =>
    new Promise<void>((resolve, reject) =>
      httpClient
        .sendHttpRequest({
          endpoint: `/api/users/${account.uuid}`,
          method: HttpMethods.PATCH,
          data: { preferences },
        })
        .then(() => resolve())
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { editUserPreferences };
